import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ModelRequeteDto } from "../../dto/GenApi.iNotPaie.Dto/ModelRequeteDto";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { EventBus } from "../Controls/EventBus";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import EventConstants from "../Controls/EventConstants";
import { Route } from "vue-router";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Component({
	beforeRouteEnter(to: Route, from: Route, next: any) {
		next(v => {
			const vm = (v as RequeteurComponent);
			vm.InitModel();
		});
	},
	beforeRouteUpdate(to: Route, from: Route, next: any) {
		next();
		(this as RequeteurComponent).InitModel();
	}
})
export default class RequeteurComponent extends Vue {
	private tab = 1;
	private modeTuiles = false;
	private modeArchive = false;
	private models: ModelRequeteDto[] = [];
	private modelsFilter: ModelRequeteDto[] = [];

	public mounted(): void {
		this.InitModel();
	}

	private InitModel(): void {
		ServicesFactoryInstance.ModelRequeteService.initModels(data => {
			this.modelsFilter = this.models = data;
			this.FilterModel();
			this.$forceUpdate();
		});
	}

	private FilterModel(): void {
		if (this.tab === 1) {
			this.modelsFilter = this.models.filter(item => !item.Style.CanDelete);
		} else if (this.tab === 2 && !this.modeArchive) {
			this.modelsFilter = this.models.filter(item => item.Style.CanDelete && !item.EstArchive);
		} else if (this.tab === 2 && this.modeArchive) {
			this.modelsFilter = this.models.filter(item => item.Style.CanDelete && item.EstArchive);
		}
	}

	private ArchiveModel(model: ModelRequeteDto): void {
		this.SwitchArchiveModel(model, true);
	}

	private RestoreModel(model: ModelRequeteDto): void {
		this.SwitchArchiveModel(model, false);
	}

	public DownloadModel(model: ModelRequeteDto): void {
		NotificationServiceInstance.SendSuccess("La demande de requête a été prise en compte. Le document sera bientôt disponible");
		ServicesFactoryInstance.RequeteurService.exportDataId(model.Id, (r: Blob) => {
			const libelle = "requete " + model.Name + ".xls";

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(r, libelle);
			} else {
				const link = document.createElement("a");
				document.body.appendChild(link);

				link.href = window.URL.createObjectURL(r);
				link.download = libelle;
				link.click();

				NotificationServiceInstance.SendSuccess("La requête s'est correctement déroulée !");
			}
		});
		this.$forceUpdate();
	}

	private SwitchArchiveModel(model: ModelRequeteDto, isArchive: boolean): void {
		const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "Souhaitez-vous vraiment " + ((isArchive) ? "archiver" : "restaurer") + " ce modèle ?",
			callBackYes: () :void => {
				model.EstArchive = isArchive;
				ServicesFactoryInstance.ModelRequeteService.updateModel(model, () => {
					NotificationServiceInstance.SendSuccess("Modèle " + ((isArchive) ? "archivé" : "restauré") + " avec succès !");
					this.InitModel();
				});
			}
		});
		EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	private SwitchDisplayArchive(): void {
		this.modeArchive = !this.modeArchive;
		this.FilterModel();
	}

	private SwitchNav(index: number): void {
		if (index === 1) {
			this.modeArchive = false;
		}
		this.tab = index;
		this.FilterModel();
	}

	private SwitchDisplayMode(modeTuiles: boolean): void {
		this.modeTuiles = modeTuiles;
	}

	private CreateModel(model: ModelRequeteDto): void {
		EventBus.NavigateTo({
			path: "/requeteurModifieur/" + 0,
			query: {
				titre: "Ajout d'un modèle",
				cloneID: model.Id.toString()
			}
		});
	}

	// -------------------------------------------------------- ROUTE

	private OpenTabView(model: ModelRequeteDto): void {
		EventBus.NavigateTo({
			path: "/requeteurTable/" + model.Id,
			query: { titre: "(Aperçu) " + model.Name }
		});
	}

	private OpenTabAdd(): void {
		EventBus.NavigateTo({
			path: "/requeteurModifieur/" + 0,
			query: { titre: "Ajout d'un modèle" }
		});
	}

	private OpenTabUpdate(model: ModelRequeteDto): void {
		EventBus.NavigateTo({
			path: "/requeteurModifieur/" + model.Id,
			query: { titre: "Modification d'un modèle" }
		});
	}
}



// WEBPACK FOOTER //
// ./src/components/requeteur/requeteur.ts